const guide  = [
  {
    path: '/guide',
    name: 'guide',
    component: () => import('views/hospitalGuide/hospitalGuide.vue'),
    // children :[
    //   {
    //     path: 'introduction',
    //     name: 'introduction',
    //     component: () => import('views/home/info/introduction.vue'),
    //     meta:{
    //       child:true,
    //       showtabbarfalse: true,
    //     }
    //   }
    // ]
  }
]
export default guide